module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.visible,
      "max-width": "860",
      "width": "860",
      "content-class": "premium-dialog"
    },
    on: {
      "input": _vm.onDialogInput
    }
  }, [(_vm.pagamento) ? _c('v-card', {
    staticClass: "pa-0 dialog-card"
  }, [_c('v-toolbar', {
    staticClass: "pt-2",
    attrs: {
      "flat": "",
      "color": "white",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "subheading font-weight-bold grey--text text--darken-2"
  }, [_vm._v("\n        REGISTRAR PAGAMENTO\n      ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-6 pt-2 pb-5 dialog-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-4 mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "headline verde--text font-weight-medium"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.pagamento.valor)))]), _vm._v(" "), _c('div', {
    staticClass: "subheading grey--text mt-1"
  }, [_c('strong', [_vm._v(_vm._s(_vm.pagamento.descricao))])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "detalhes-box pa-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Vencimento")]), _vm._v(" "), _c('div', {
    staticClass: "body-2"
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.pagamento.data_vencimento)))])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2 detalhe-direita",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "body-2"
  }, [_c('strong', [_vm._v(_vm._s(_vm.pagamento.status ? _vm.pagamento.status.toUpperCase() : '---'))])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "premium-input",
    attrs: {
      "label": "Data do Pagamento",
      "type": "date",
      "required": "",
      "hint": _vm.data_pagamento ? ("Data selecionada: " + (_vm.formatDate(_vm.data_pagamento))) : 'Formato de exibição: dd/mm/aaaa',
      "persistent-hint": ""
    },
    model: {
      value: (_vm.data_pagamento),
      callback: function($$v) {
        _vm.data_pagamento = $$v
      },
      expression: "data_pagamento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "upload-zone text-xs-center pa-4 mt-3",
    class: {
      'has-file': _vm.file
    },
    on: {
      "click": function($event) {
        _vm.$refs.fileInput.click()
      }
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*,application/pdf"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), (!_vm.file) ? [_c('v-icon', {
    attrs: {
      "size": "32",
      "color": "grey lighten-1"
    }
  }, [_vm._v("cloud_upload")]), _vm._v(" "), _c('div', {
    staticClass: "subheading grey--text text--darken-1 mt-2"
  }, [_vm._v("Anexar Comprovante")]), _vm._v(" "), _c('div', {
    staticClass: "caption grey--text lighten-1"
  }, [_vm._v("* Obrigatório (PDF ou Imagem)")])] : [_c('v-icon', {
    attrs: {
      "size": "32",
      "color": "green"
    }
  }, [_vm._v("check_circle_outline")]), _vm._v(" "), _c('div', {
    staticClass: "subheading green--text text--darken-1 mt-2 text-truncate",
    staticStyle: {
      "max-width": "100%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.fileName) + "\n                ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-1",
    attrs: {
      "small": "",
      "flat": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.resetFile($event)
      }
    }
  }, [_vm._v("Trocar arquivo")])]], 2)])], 1)], 1)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-3 dialog-actions"
  }, [_c('v-btn', {
    staticClass: "font-weight-bold btn-cancelar",
    attrs: {
      "flat": "",
      "large": "",
      "color": "grey"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "verde px-4 font-weight-bold btn-acao-principal btn-registrar",
    attrs: {
      "dark": "",
      "large": "",
      "loading": _vm.loading,
      "disabled": !_vm.file || !_vm.data_pagamento || _vm.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("payment")]), _vm._v(" Registrar\n      ")], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ebe5680"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Pagamentos/PagamentosPagar.vue
// module id = 984
// module chunks = 1